import { UPDATE_DEPARTMENTLIST } from '../constants/department'

export const updateDepartment = (departmentList) => {
    return dispatch => {
        dispatch({
            type: UPDATE_DEPARTMENTLIST,
            departmentList
        });
    };
};